import appRoutes from '@/router/routes/app.js'

export default appRoutes